import React, { useEffect, useState } from 'react';
import { FileText } from 'lucide-react';

// Which Terms of Trade go with a quote. Default comes from Report Setup → Terms of Trade.
export const TERMS_MODES = [
  { key: 'simple', label: 'Simple' },
  { key: 'full', label: 'Full' },
  { key: 'both', label: 'Both' },
  { key: 'none', label: 'None' },
];

const TERMS_DOCS = {
  simple: { key: 'terms_simple', kind: 'terms_of_trade_simple', route: '/reports/terms-of-trade-simple/{appraisal_id}', label: 'Terms of Trade (Simple)', perQuote: true },
  full: { key: 'terms_full', kind: 'terms_of_trade', route: '/reports/terms-of-trade/{appraisal_id}', label: 'Terms of Trade (Full)' },
};

export function termsDocsFor(mode) {
  if (mode === 'both') return [TERMS_DOCS.simple, TERMS_DOCS.full];
  return TERMS_DOCS[mode] ? [TERMS_DOCS[mode]] : [];
}

// jobId: a per-job pick (made in Preview or Send) is kept for this browser session.
export function useQuoteTermsMode(api, enabled = true, jobId = '') {
  const storeKey = jobId ? `quoteTermsMode:${jobId}` : '';
  const [mode, setModeState] = useState(null);
  useEffect(() => {
    if (!enabled) return;
    const saved = storeKey && sessionStorage.getItem(storeKey);
    if (saved) { setModeState(saved); return; }
    api.get('/report-settings/quote-terms')
      .then(({ data }) => setModeState(data?.mode || 'simple'))
      .catch(() => setModeState('simple'));
  }, [api, enabled, storeKey]);
  const setMode = (m) => { setModeState(m); if (storeKey) sessionStorage.setItem(storeKey, m); };
  return [mode, setMode];
}

export function QuoteTermsPicker({ mode, onChange, disabled }) {
  return (
    <div className="mb-5 p-3 border border-slate-200 rounded bg-slate-50 flex flex-wrap items-center gap-3" data-testid="wf-send-terms-picker">
      <FileText size={14} className="text-slate-500" />
      <span className="text-sm font-semibold text-slate-700">Terms of Trade to attach:</span>
      <div className="flex gap-1">
        {TERMS_MODES.map((m) => (
          <button
            key={m.key}
            type="button"
            disabled={disabled}
            onClick={() => onChange(m.key)}
            data-testid={`wf-send-terms-${m.key}`}
            className={`px-3 py-1 rounded text-xs font-semibold border transition-colors ${mode === m.key ? 'bg-orange-600 text-white border-orange-600' : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-100'} disabled:opacity-50`}
          >
            {m.label}
          </button>
        ))}
      </div>
    </div>
  );
}
